(function () {
    'use strict';

    angular
        .module('app')
        .factory('UserService', UserService);

    UserService.$inject = ['$http'];

    function UserService($http) {

        var service = {
            Recuperarpassword: Recuperarpassword,
            Changepassword: Changepassword,
            Login: Login,
            Solicitudform: Solicitudform,
            UpdateProfile: UpdateProfile,
            GetProfile: GetProfile,
            Registroform: Registroform

        };

        function UpdateProfile(ProfileForm) {
            return $http.post('/ajax/updateprofile', { "ProfileForm": ProfileForm }, { headers: {} }).then((data) => {
                return data.data;
            });
        }

        function GetProfile(vm) {
            return $http.get('/ajax/getprofile', { headers: {} }).then((data) => {
                return data.data;
            });
        }

        function Recuperarpassword(vm) {
            var config = {
                headers: {}
            }
            return $http.post('/ajax/recoverypassword', {
                RecoveryForm: {
                    username: vm.username,
                    msgemail: vm.msgemail
                }
            }, config)

                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };

        function Changepassword(vm) {
            var config = {
                headers: {}
            }
            return $http.post('/ajax/recoverypassword', {
                RecoveryForm: {

                    password: vm.password,
                    password_rep: vm.password_rep,
                    token: vm.token
                },
                action: "change"
            }, config)

                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };

        function Login(vm) {
            var config = {
                headers: {}
            }
            return $http.post(
                '/ajax/login', {
                LoginForm: { username: vm.username, password: vm.password, name: vm.name }
            }
                , config)
                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });


        };

        function Solicitudform(vm) {
            var config = {
                headers: {
                    // 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            return $http.post('/ajax/realizarsolicitud', {
                user_id: vm.user_id,
                activo_id: vm.activo_id,
                texto: vm.texto,
                fecha_oferta: vm.fecha_oferta,
            }, config)

                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };

        function Registroform(vm) {
            var config = {
                headers: {
                    // 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            return $http.post('/ajax/registro', {
                nombre: vm.nombre,
                apellidos: vm.apellidos,
                dni: vm.dni,
                direccion: vm.direccion,
                localidad: vm.localidad,
                pais: vm.pais,
                cp: vm.cp,
                email: vm.email,
                telefono: vm.telefono,
                password: vm.password,
                conocido: vm.conocido,
                politica: vm.politica,
                persona: vm.persona,
                nifEmpresa:vm.nifEmpresa,
                nombreEmpresa:vm.nombreEmpresa,
                password: vm.password,
                password_rep: vm.password_rep,
                user: vm.user,
            }, config)

                .then(function (data) {
                    return data.data;
                }, function (data) {
                    return data;
                });
        };




        return service;

    }

})();